import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE_TOKEN = new InjectionToken<Storage>('[Meeting Scheduler]: token for local storage', {
  providedIn: 'root',
  factory: function (): Storage {
    if (typeof localStorage !== 'undefined') {
      return localStorage;
    }
    return new LocalStorageStub();
  },
});

class LocalStorageStub implements Storage {
  [name: string]: any;

  readonly length: number = 0;

  clear(): void {
    throw new Error('Method not implemented.');
  }

  getItem(): string | null {
    return null;
  }

  key(): string | null {
    return null;
  }

  removeItem(): void {
    throw new Error('Method not implemented.');
  }

  setItem(): void {
    throw new Error('Method not implemented.');
  }
}
